import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { PropertyCard } from "@/components/PropertyCard";
import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";

export default function Favorites() {
  const [items, setItems] = useState(null);
  useEffect(() => { api.get("/favorites").then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <div className="scent-wave min-h-[calc(100vh-4rem)]">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-12">
        <div className="text-xs tracking-[0.28em] uppercase text-emerald-700 font-semibold">Guest · Saved Stays</div>
        <h1 className="mt-2 font-serif text-4xl md:text-5xl tracking-tight text-[#0A1128]">Your favorites.</h1>
        <p className="mt-3 text-slate-600">Certified stays you&apos;re keeping an eye on.</p>

        {items === null ? (
          <div className="mt-16 text-center text-slate-500">Loading…</div>
        ) : items.length === 0 ? (
          <div className="mt-16 rounded-3xl border border-dashed border-slate-300 p-16 text-center bg-white" data-testid="favorites-empty">
            <Heart className="w-10 h-10 text-slate-300 mx-auto" />
            <h2 className="mt-4 font-serif text-2xl text-[#0A1128]">No favorites yet</h2>
            <p className="mt-2 text-slate-500 text-sm">Tap the Save button on any property to add it here.</p>
            <Link to="/browse"><Button className="mt-6 rounded-full bg-[#0A1128] hover:bg-[#1A2A3A] text-white" data-testid="favorites-browse">Browse certified stays</Button></Link>
          </div>
        ) : (
          <div className="mt-10 grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="favorites-grid">
            {items.map((p, i) => <PropertyCard key={p.id} p={p} idx={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
